// @ts-strict-ignore
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Typography, useToast } from "@aviary";
import { l } from "@emerson/locales/i18n";
import { EmailInput } from "@shared/components/EmailInput/EmailInput";
import {
  isEmailDotValid,
  isBasicEmailValid,
} from "@shared/components/EmailInput/EmailValidation/EmailValidation";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { isEEStaging, isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import * as styles from "./Newsletter.styles";

const Newsletter = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const [isEmailDirty, setIsEmailDirty] = useState(false);
  const [email, setEmail] = useState<string>("");
  const { makeToast } = useToast();

  const handleEmailOnBlur = e => {
    if (e.target.value) {
      setIsEmailDirty(true);
      setEmail(e.target.value);
    }
  };

  const validateEmail = () => {
    return isEmailDotValid(email) && isBasicEmailValid(email);
  };

  const subscribeNewsLetter = async () => {
    const requestBody = { email };
    const publicIdString =
      isProduction() || isEEStaging()
        ? window.ENV.EMERSON_NEWSLETTER_PROD_ID
        : window.ENV.EMERSON_NEWSLETTER_ID;
    try {
      const response = await fetch(
        "//links.iterable.com/lists/publicAddSubscriberForm?publicIdString=" + publicIdString,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      if (response.ok) {
        const newTab = window.open();
        newTab.document.write(await response.text());
      }
    } catch {
      makeToast("error", t(l.newsletter.Error));
    }
  };

  return (
    <div css={styles.NewsletterWrapper}>
      <div css={styles.NewsletterContainer}>
        <Typography type="h3" css={styles.AlignCenter}>
          {t(l.newsletter.Title)}
        </Typography>
        <Typography type="body" css={styles.AlignCenter}>
          {t(l.newsletter.Description)}
        </Typography>
        <div css={tablet.greaterThan ? styles.FormContainer : styles.MobileFormContainer}>
          <div css={styles.EmailInput}>
            <EmailInput
              hideSuggestion
              isDirty={isEmailDirty}
              value={email}
              setEmail={setEmail}
              onBlur={handleEmailOnBlur}
              onChange={event => setEmail(event.target.value)}
            />
          </div>
          <Button
            size="large"
            disabled={!!isEmailDirty && !validateEmail()}
            onClick={subscribeNewsLetter}
          >
            {t(l.newsletter.Subscribe)}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { Newsletter };
